import { Component, effect, inject, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { MultiSelectModule } from 'primeng/multiselect';
import { firstValueFrom } from 'rxjs';
import { TripService } from 'src/app/trip-calculator/services/trip.service';

@Component({
  selector: 'app-scheduled-days-selector',
  imports: [TranslocoPipe, MultiSelectModule, ReactiveFormsModule],
  templateUrl: './scheduled-days-selector.component.html',
})
export class ScheduledDaysSelectorComponent implements OnInit {
  @Input() formGroup!: FormGroup;
  tripService = inject(TripService);
  translocoService = inject(TranslocoService);
  availableDaysOptions: { label: string; value: number }[] = [];
  constructor() {
    effect(() => {
      this.updateTripLength(this.tripService.trip()?.days);
    });
  }

  ngOnInit() {
    this.updateTripLength(1);
  }

  private async updateTripLength(length: number | undefined) {
    if (!length) {
      console.error(
        `Invalid tripLength value: received '${length}'. Expected a positive integer. Please check the TripService or form input for errors.`,
      );
      return;
    }
    const translatedDay = await firstValueFrom(
      this.translocoService.selectTranslate('travelBoards.day'),
    );

    const baseDays = Array.from({ length }, (_, i) => i + 1);

    // Keep selected days beyond the trip length (e.g. AI returns day 11 on an
    // 8-day trip) so the multiselect can render their chip instead of an empty one.
    const selectedDays: number[] =
      this.formGroup.get('scheduledDays')?.value ?? [];
    const outOfRangeDays = selectedDays.filter((day) => day > length);

    const allDays = [...new Set([...baseDays, ...outOfRangeDays])].sort(
      (a, b) => a - b,
    );

    this.availableDaysOptions = allDays.map((value) => ({
      label: `${translatedDay} ${value}`,
      value,
    }));
  }
}
